<div ngbDropdown container="body" placement="auto">
  <div
    ngbDropdownToggle
    (openChange)="markAsSeen($event)"
    class="notif-center no-pseudo-after">
    <div class="d-flex gap-2 align-items-center p-2">
      <i class="icon-messages"></i>
      <span class="position-relative">Notifications</span>
      <span class="notif-circle" *ngIf="unseenCount">
        {{ unseenCount > 99 ? '&infin;' : unseenCount }}
      </span>
    </div>

    <div ngbDropdownMenu class="notif-menu">
      <div class="cards">
        <div class="text-break" *ngIf="notifications.length === 0">
          Notifications from activity by your peers on ideas that you are
          working together on will appear here.
        </div>
        <div
          class="card"
          *ngFor="let notif of notifications"
          [ngClass]="{ read: notif.read }">
          <div
            class="inside collab-added"
            *ngIf="notif.meta.type === 'collab_added'"
            (click)="openIdeaModal(notif)">
            <div class="avatar">
              <img
                alt
                [src]="
                  notif.meta.idea.thumbnail_id ||
                    'image/default_session_thumbnail.png' | assets
                " />
            </div>
            <div class="text" *ngIf="!personal(notif)">
              {{ notif.meta.collaborator.user.name }} was added as a
              collaborator to
              <span class="in-card-link">{{ notif.meta.idea.title }}</span>
              in session
              <span class="in-card-link" (click)="openSession(notif, $event)">
                {{ notif.meta.session.config.title }}
              </span>
              .
            </div>
            <div class="text" *ngIf="personal(notif)">
              You were added as a collaborator to
              <span class="in-card-link">{{ notif.meta.idea.title }}</span>
              in session
              <span class="in-card-link" (click)="openSession(notif, $event)">
                {{ notif.meta.session.config.title }}
              </span>
              .
            </div>
          </div>

          <div
            class="inside collab-requested"
            *ngIf="notif.meta.type === 'collab_requested'"
            (click)="openIdeaModal(notif)">
            <div class="avatar">
              <img
                alt
                [src]="
                  notif.meta.idea.thumbnail_id ||
                    'image/default_session_thumbnail.png' | assets
                " />
            </div>
            <div class="text">
              {{ notif.meta.requestor.user.name }} has requested to become a
              collaborator on
              <span class="in-card-link">{{ notif.meta.idea.title }}</span>
              in session
              <span class="in-card-link" (click)="openSession(notif, $event)">
                {{ notif.meta.session.config.title }}
              </span>
              .
            </div>
          </div>

          <div
            class="inside collab-invited"
            *ngIf="notif.meta.type === 'collab_invited'"
            (click)="openIdeaModal(notif)">
            <div class="avatar">
              <img
                alt
                [src]="
                  notif.meta.idea.thumbnail_id ||
                    'image/default_session_thumbnail.png' | assets
                " />
            </div>
            <div class="text">
              You were invited to collaborate on
              <span class="in-card-link">{{ notif.meta.idea.title }}</span>
              in session
              <span class="in-card-link" (click)="openSession(notif, $event)">
                {{ notif.meta.session.config.title }}
              </span>
              .
            </div>
          </div>

          <div
            class="inside comment-added"
            *ngIf="notif.meta.type === 'comment_added'"
            (click)="openIdeaModal(notif)">
            <div class="avatar">
              <img
                alt
                [src]="
                  notif.meta.idea.thumbnail_id ||
                    'image/default_session_thumbnail.png' | assets
                " />
            </div>
            <div class="text">
              {{ notif.meta.user.name }} commented on
              <span class="in-card-link">{{ notif.meta.idea?.title }}</span>
              in topic
              <span class="in-card-link" (click)="openSession(notif, $event)">
                {{ notif.meta.session.config?.title }}
              </span>
              .
            </div>
          </div>

          <div
            class="inside mentioned-in-comment"
            *ngIf="notif.meta.type === 'mentioned_in_comment'"
            (click)="openIdeaModal(notif)">
            <div class="avatar">
              <img
                alt
                [src]="
                  notif.meta.idea.thumbnail_id ||
                    'image/default_session_thumbnail.png' | assets
                " />
            </div>
            <div class="text">
              {{ notif.meta.comment.author.name }} mentioned you in a comment on
              <span class="in-card-link">{{ notif.meta.idea?.title }}</span>
              in topic
              <span class="in-card-link" (click)="openSession(notif, $event)">
                {{ notif.meta.session.config?.title }}
              </span>
              .
            </div>
          </div>

          <div
            class="inside comment-replied"
            *ngIf="notif.meta.type === 'comment_replied'"
            (click)="openIdeaModal(notif)">
            <div class="avatar">
              <img
                alt
                [src]="
                  notif.meta.idea.thumbnail_id ||
                    'image/default_session_thumbnail.png' | assets
                " />
            </div>
            <div class="text">
              {{ notif.meta.comment.author.name }} replied to your comment on
              <span class="in-card-link">{{ notif.meta.idea?.title }}</span>
              in topic
              <span class="in-card-link" (click)="openSession(notif, $event)">
                {{ notif.meta.session.config?.title }}
              </span>
              .
            </div>
          </div>

          <div
            class="inside direct-message"
            *ngIf="notif.meta.type === 'direct_message'"
            (click)="openDMModal(notif)">
            <div class="avatar">
              <img
                alt
                [src]="
                  notif.meta.user.profile_picture ||
                    'image/default_profile_picture.png' | assets
                " />
            </div>
            <div class="text">
              {{ notif.meta.user.name }} sent you a direct message!
            </div>
          </div>

          <div
            class="inside group-chat-announcement"
            *ngIf="notif.meta.type === 'group_chat_announcement'"
            (click)="openGCModal(notif)">
            <div class="avatar">
              <img
                alt
                [src]="
                  notif.meta.image || 'image/default_session_thumbnail.png'
                    | assets
                " />
            </div>
            <div class="text">{{ notif.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
